import * as React from 'react';
import { Box, Label } from '@front10/base-elements';
import { useRadioGroupState } from '@react-stately/radio';
import type { CSSObject } from '@theme-ui/css';
import RadioButton from '../RadioButton/RadioButton';

interface Option {
  value: string;
  label: string;
  href?: string;
  name?: string;
}

interface RadioButtonProps {
  options: Array<Option>;
  defaultOption: string;
  onChange: (value: string) => void;
  orientation: 'horizontal' | 'vertical';
  itemsContainerStyle: CSSObject;
  itemsStyle: CSSObject;
}

const RadioButtonGroup = (props: RadioButtonProps) => {
  const {
    options,
    defaultOption,
    onChange,
    orientation = 'horizontal',
    itemsContainerStyle = {},
    itemsStyle = {}
  } = props;

  const state = useRadioGroupState({
    defaultValue: defaultOption,
    value: defaultOption,
    orientation: orientation,
    onChange: onChange
  });

  React.useEffect(() => {
    state.setSelectedValue(defaultOption);
  }, [defaultOption, state]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '5px',
        flexDirection: orientation === 'horizontal' ? 'row' : 'column',
        ...itemsContainerStyle
      }}
    >
      {options.map((opt) => (
        <Label
          variant="text.fontSize5"
          sx={{
            color: 'text',
            width: 'unset',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            '>input': {
              width: 20,
              height: 20,
              cursor: 'pointer'
            },
            ...itemsStyle
          }}
        >
          <RadioButton
            key={opt.value}
            name={opt.value}
            isChecked={state.selectedValue === opt.value}
            onChange={() => state.setSelectedValue(opt.value)}
          />
          {opt.label}
        </Label>
      ))}
    </Box>
  );
};

export default RadioButtonGroup;
